module.exports = __webpack_public_path__ + "static/flags/SW-1140f871292a4c0e110d446d30d01891.gif";